<template>
  <div class="type-box">

    <!-- 年份 -->
    <div ref="year" class="year" :class="{'active-option':activeType.newVal =='year'}" @mouseleave="mouseLeave('year')"
      @mouseenter="mouseEnter('year')">
      <div class="year-title">
        <span>年份：<span>{{year}}</span></span>
        <i class="el-icon-arrow-down"></i>
      </div>
      <div class="type-shade"></div>
    </div>

    <!-- 类型 -->
    <div ref="ptype" class="ptype" :class="{'active-option':activeType.newVal=='ptype'}"
      @mouseleave="mouseLeave('ptype')" @mouseenter='mouseEnter("ptype")'>
      <div class="ptype-title">
        <span>类型：<span>{{ptype}}</span></span>
        <i class="el-icon-arrow-down"></i>
      </div>
      <div class="type-shade"></div>
    </div>

    <!-- 地区 -->
    <div ref="area" class="area" :class="{'active-option':activeType.newVal=='area'}" @mouseleave="mouseLeave('area')"
      @mouseenter='mouseEnter("area")'>
      <div class="area-title">
        <span>地区：<span>{{area}}</span></span>
        <i class="el-icon-arrow-down"></i>
      </div>
      <div class="type-shade"></div>
    </div>

    <!-- 展示内容 -->
    <div @mouseleave="mouseLeave('typeOption')" @mouseenter='mouseEnter("typeOption")'
      @click.stop="optionClick('typeOption')" ref="typeOption" class="type-option">
      <div class="type-option-box">
        <el-radio @change='optionChange' v-for="(item,i) of currentDataList" :key="item.name+i"
          v-model="typeObj[bindType()]" :label="item.name">
        </el-radio>
      </div>
    </div>

  </div>
</template>

<script>
import { getDictBatch } from "@/network/resourceRequest/api";
export default {
  name: "TypeNav",
  data() {
    return {
      //年份--------------------------------------------
      yearDataList: [],
      year: "全部",
      //类型--------------------------------------------
      ptypeDataList: [],
      ptype: "全部",

      //地区--------------------------------------------
      areaDataList: [
        {
          name: "全部",
          label: "全部"
        },
        {
          name: "北京市",
          label: "北京市"
        },
        {
          name: "天津市",
          label: "天津市"
        },
        {
          name: "上海市",
          label: "上海市"
        },
        {
          name: "重庆市",
          label: "重庆市"
        },
        {
          name: "河北省",
          label: "河北省"
        },
        {
          name: "山西省",
          label: "山西省"
        },
        {
          name: "辽宁省",
          label: "辽宁省"
        },
        {
          name: "吉林省",
          label: "吉林省"
        },
        {
          name: "黑龙江省",
          label: "黑龙江省"
        },
        {
          name: "江苏省",
          label: "江苏省"
        },
        {
          name: "浙江省",
          label: "浙江省"
        },
        {
          name: "安徽省",
          label: "安徽省"
        },
        {
          name: "福建省",
          label: "福建省"
        },
        {
          name: "江西省",
          label: "江西省"
        },
        {
          name: "山东省",
          label: "山东省"
        },
        {
          name: "河南省",
          label: "河南省"
        },
        {
          name: "湖北省",
          label: "湖北省"
        },
        {
          name: "湖南省",
          label: "湖南省"
        },
        {
          name: "广东省",
          label: "广东省"
        },

        {
          name: "海南省",
          label: "海南省"
        },
        {
          name: "四川省",
          label: "四川省"
        },
        {
          name: "贵州省",
          label: "贵州省"
        },
        {
          name: "云南省",
          label: "云南省"
        },
        {
          name: "陕西省",
          label: "陕西省"
        },
        {
          name: "甘肃省",
          label: "甘肃省"
        },
        {
          name: "青海省",
          label: "青海省"
        },
        {
          name: "台湾省",
          label: "台湾省"
        },
        {
          name: "内蒙古自治区",
          label: "内蒙古自治区"
        },
        {
          name: "广西壮族自治区",
          label: "广西壮族自治区"
        },
        {
          name: "西藏自治区",
          label: "西藏自治区"
        },
        {
          name: "宁夏回族自治区",
          label: "宁夏回族自治区"
        },
        {
          name: "新疆维吾尔自治区",
          label: "新疆维吾尔自治区"
        },
        {
          name: "香港特别行政区",
          label: "香港特别行政区"
        },
        {
          name: "澳门特别行政区",
          label: "澳门特别行政区"
        }
      ],
      area: "全部",

      // 绑定数据
      typeObj: {
        year: "全部",
        ptype: "全部",
        area: "全部"
      },

      // 当前激活数组
      currentDataList: [],
      // 当前激活类型
      activeType: { oldVal: "", newVal: "" }
    };
  },

  created() {
    //初始化信息--------------------------------------------
    this.init();
  },

  methods: {
    //初始化数据--------------------------------------------
    init() {
      //年份--------------------------------------------
      this.yearDataList = [
        { name: "全部" },
        { name: "2020" },
        { name: "2019" },
        { name: "2018" },
        { name: "2017" },
        { name: "2016" },
        { name: "2015" },
        { name: "2014" },
        { name: "2013" }
      ];

      //类型--------------------------------------------
      getDictBatch({ types: "ptype" }).then(res => {
        if (res.data.success) {
          this.ptypeDataList = res.data.data.ptype;
          this.ptypeDataList.unshift({ name: "全部" });
          // this.ptype = res.data.data.ptype[0].name;
          // this.$set(this.typeObj, "ptype", this.ptype);
        }
      });
    },

    //返回绑定类型
    bindType() {
      if (this.activeType.newVal) {
        return this.activeType.newVal;
      }
    },

    //选择
    optionChange(e) {
      if (this.activeType.newVal == "year") {
        this.year = e;
        this.$set(this.typeObj, "year", e);
      } else if (this.activeType.newVal == "ptype") {
        this.ptype = e;
      } else if (this.activeType.newVal == "area") {
        this.area = e;
      }
      this.$emit("typeObj", this.typeObj);
    },

    //关闭选项--------------------------------------------
    optionClick(type) {
      this.$refs.typeOption.style.height = "0";
      this.$refs.typeOption.style.minHeight = "0";
      this.$refs.typeOption.style.padding = "0";
    },

    //鼠标进入
    mouseEnter(type) {
      // 更改选项
      if (type == "year") {
        this.currentDataList = this.yearDataList;
      } else if (type == "ptype") {
        this.currentDataList = this.ptypeDataList;
      } else if (type == "area") {
        this.currentDataList = this.areaDataList;
      }

      //给激活状态
      if (type == "typeOption") {
        this.$set(this.activeType, "newVal", this.activeType.oldVal);
        this.$refs.typeOption.style.height = "auto";
        this.$refs.typeOption.style.minHeight = "50px";
      } else {
        this.$set(this.activeType, "newVal", type);
        this.$refs.typeOption.style.height = "auto";
        this.$refs.typeOption.style.minHeight = "50px";
      }
    },

    //鼠标离开选择盒子
    mouseLeave(type) {
      this.$set(this.activeType, "oldVal", this.activeType.newVal);
      this.$set(this.activeType, "newVal", "");
      this.$refs.typeOption.style.height = "0";
      this.$refs.typeOption.style.minHeight = "0";
      this.$refs.typeOption.style.padding = "0";
    }
  }
};
</script>



<style lang="less" scoped>
.type-box {
  display: flex;
  height: 40px;
  align-items: center;

  // 时间
  .year,
  .ptype,
  .area {
    height: 100%;
    display: flex;
    align-items: center;
    border-radius: 3px;
    padding: 0 10px 0 19px;
    position: relative;

    .year-title,
    .ptype-title,
    .area-title {
      user-select: none;
      position: relative;
      & > span {
        margin-right: 5px;
        font-size: 14px;
        color: rgba(85, 85, 85, 1);

        span {
          color: #24ba58;
        }
      }
    }
  }

  // 内容展示
  .type-option {
    width: 960px;
    height: 0;
    overflow: hidden;
    border-radius: 3px;
    position: absolute;
    top: 60px;
    left: 0px;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
    background-color: #fff;
    display: flex;
    flex-wrap: wrap;
    z-index: 3000;

    .type-option-box {
      display: flex;
      flex-wrap: wrap;
      height: 100%;
      padding: 10px;
    }
  }

  //激活样式
  .active-option {
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);

    .type-shade {
      bottom: -9px;
      position: absolute;
      width: 100%;
      left: 0;
      height: 20px;
      background: #fff;
      z-index: 3001;
    }
  }

  .el-radio {
    margin: 10px;

    /deep/ .el-radio__input {
      display: none;
    }
    /deep/ .el-radio__label {
      padding-left: 0;

      font-size: 14px;
      font-weight: 400;

      color: rgba(51, 51, 51, 1);
      color: #333;
    }

    /deep/ .el-radio__input.is-checked + .el-radio__label {
      color: #24ba58;
    }
  }

  .el-radio:hover {
    /deep/ .el-radio__label {
      color: #24ba58;
    }
  }
}
</style>